// Note: Please use ITag from tag module interfae
export interface ITagOld {
  id :number;
  name :string;
}

export enum ETag {
  FLAGGED = 'FLAGGED',
}
